// extracted by mini-css-extract-plugin
var _1 = "CopiedToTagList-moduleitems__f2sil MultiValuedListItems-moduleMultiValuedListItems__sFyGz";
var _2 = "CopiedToTagList-modulelist__SIWfw MultiValuedList-moduleMultiValuedList__ZJwbV";
var _3 = "CopiedToTagList-modulemoreButton__HkS2s MultiValuedListMoreButton-moduleMultiValuedListMoreButton__uXKl3";
export { _1 as "items", _2 as "list", _3 as "moreButton" }
